import React, { useEffect, useState } from "react";
import styles from "./Toast.module.css";

import { FaCheckCircle, FaExclamationTriangle, FaTimesCircle, FaTimes } from "react-icons/fa";

function hexToRgba(hex, alpha = 0.85) {
  if (!hex) return `rgba(45,45,45,${alpha})`;
  let h = hex.replace("#", "");
  if (h.length === 3)
    h = h
      .split("")
      .map((c) => c + c)
      .join("");
  const r = parseInt(h.slice(0, 2), 16);
  const g = parseInt(h.slice(2, 4), 16);
  const b = parseInt(h.slice(4, 6), 16);
  if ([r, g, b].some((n) => Number.isNaN(n))) return `rgba(45,45,45,${alpha})`;
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}

const Toast = ({ id, message, autoDismiss, level, onClose, color }) => {
  const [visible, setVisible] = useState(false);
  const [isCompact, setIsCompact] = useState(typeof window !== "undefined" ? window.innerWidth <= 1400 : false);

  useEffect(() => {
    setVisible(true);
    let timer;
    if (autoDismiss) {
      timer = setTimeout(() => {
        setVisible(false);
        setTimeout(() => onClose(id), 600);
      }, 6000);
    }
    return () => clearTimeout(timer);
  }, [id, autoDismiss, onClose]);

  useEffect(() => {
    const onResize = () => setIsCompact(window.innerWidth <= 1400);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  const handleDismiss = () => {
    setVisible(false);
    setTimeout(() => onClose(id), 600);
  };

  const getLevelClass = () => {
    switch (level) {
      case "ERROR":
        return styles.error;
      case "WARNING":
        return styles.warning;
      case "SUCCESS":
        return styles.success;
      case "CUSTOM":
        return styles.custom;
      default:
        return "";
    }
  };

  const getCustomStyle = () =>
    level === "CUSTOM"
      ? {
          backgroundColor: hexToRgba(color, 0.85),
          width: isCompact ? "250px" : "350px",
          marginTop: isCompact ? "8px" : undefined,
          marginRight: isCompact ? "8px" : undefined,
        }
      : undefined;

  const renderIcon = () => {
    switch (level) {
      case "ERROR":
        return <FaTimesCircle />;
      case "WARNING":
        return <FaExclamationTriangle />;
      case "SUCCESS":
        return <FaCheckCircle />;
      default:
        return null;
    }
  };

  return (
    <div
      className={`${styles.toast} ${visible ? styles.visible : ""} ${getLevelClass()}`}
      style={getCustomStyle()}
      role="alert"
      aria-live="assertive">
      <span className={styles.icon}>{renderIcon()}</span>
      <span className={styles.message} dangerouslySetInnerHTML={{ __html: message }}></span>
      {!autoDismiss && (
        <button onClick={handleDismiss} aria-label="Fermer la notification">
          <FaTimes />
        </button>
      )}
    </div>
  );
};

export default Toast;
